module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C122",
    attrs: {
      "id": "page_IX"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0007#page_i"
    }
  }, [_vm._v("Foreword to "), _c('em', [_vm._v("The Cullen Collection")])])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0009#page_IX"
    }
  }, [_vm._v("Introduction to "), _c('em', [_vm._v("The Marquis of Lossie")])])]), _vm._v(" "), _c('p', {
    staticClass: "C121"
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTE")]), _vm._v(": As the introductions to the 37 volumes of "), _c('em', [_vm._v("The Cullen Collection")]), _vm._v(" form a continuous portrait of George MacDonald’s life, and as many of the introductions contain comprehensive and detailed discussion and analysis of the title in question—its plot, themes, and circumstances of writing—some first-time readers may choose to skip ahead to the story itself, saving the introduction for later, so as not to “spoil the story.”")]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0013#page_1"
    }
  }, [_vm._v("1. The Stable Yard")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0014#page_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Library")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0015#page_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Miss Horn")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0016#page_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Lizzy Findlay")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0017#page_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Blue Peter")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0018#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. To London")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0019#page_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Streets of London")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0020#page_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Unsought Reunion")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0021#page_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Painter")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0022#page_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Portlossie")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0023#page_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Lord Liftore")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0024#page_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Kelpie in London")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0025#page_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Mr. Graham")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0026#page_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Richmond Park")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0027#page_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Painter and Groom")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0028#page_93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. A Lady")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0029#page_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Davy")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0030#page_103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. The Portrait")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0031#page_108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. An Evil Pass")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0032#page_115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. A Quarrel")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0033#page_121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. The Two Daimons")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0034#page_127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Confrontation")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0035#page_137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. An Old Adversary")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0036#page_144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. An Innocent Plot")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0037#page_150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. The Journey")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0038#page_153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. Discipline")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0039#page_165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. Moonlight")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0040#page_174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. St. Ronan’s Well")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    attrs: {
      "id": "page_X"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0041#page_185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. Perplexities")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0042#page_191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. The Mind of the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0043#page_195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. The Ride Home")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0044#page_201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. Portland Place")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0045#page_206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. Portlossie and Scaurnose")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0046#page_212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. The Potion")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0047#page_221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35. The Demoness at Bay")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0048#page_227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36. The Psyche")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0049#page_236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37. Nightfall at Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0050#page_243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38. Hope Chapel")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0051#page_250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39. A New Pupil")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0052#page_257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40. The Wanderer")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0053#page_265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41. Mid Ocean")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0054#page_277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42. The Piper")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0055#page_284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43. The Shore")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0056#page_290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44. The Trench")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0057#page_302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45. The Peacemaker")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0058#page_314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46. An Offering")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0059#page_322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47. Awakening")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0060#page_328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48. The Dune")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0061#page_335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49. Confession of Sin")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0062#page_342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50. A Visit to the Seaton")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0063#page_349",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51. Eve of the Crisis")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0064#page_354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52. Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0065#page_364",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53. Hearts as One")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0066#page_372",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54. The Crew of the Bonnie Annie")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0067#page_377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55. Lizzy’s Baby")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0068#page_381",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56. The Disclosure")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0069#page_390",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57. Arrival")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0070#page_394",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58. The Assembly")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    staticStyle: {
      "margin-bottom": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0071#page_406",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59. Knotted Strands")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e94be12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0004.vue
// module id = 69
// module chunks = 0